<template>
  <div class="device_selection">
    <header-component
      :is-soon="false"
      :backRoute="true"
      img-left="/trocachip/img/fechar.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />

    <div class="page_content">
      <h1 class="page_title" v-html="deviceSelectionPageMessages.title"></h1>

      <section class="device_selection_container">
        <div class="selection_container">
          <div class="selection_input" @click="toggleBrandSelectionOpened">
            <span
              v-html="brandSelected ? brandSelected : 'Selecione a marca'"
            />
          </div>
          <div
            class="selection_options_container"
            :class="{ opened_options: brandSelectionOpened }"
          >
            <label
              id="device_mark"
              v-for="(item, index) in brandsList"
              :key="index"
              v-html="item"
              :value="item"
              @click="() => selectBrand(item)"
            />
          </div>
        </div>

        <div class="selection_container">
          <div class="selection_input" @click="toggleModelSelectionOpened">
            <span
              v-html="modelSelected ? modelSelected : 'Selecione o modelo'"
            />
          </div>
          <div
            class="selection_options_container"
            :class="{ opened_options: modelSelectionOpened }"
          >
            <label
              id="device"
              v-for="(item, index) in modelsByBrand"
              :key="index"
              v-html="item"
              :value="item"
              @click="() => selectModel(item)"
            />
          </div>
        </div>

        <div class="confirmation_container">
          <input type="checkbox" v-model="checkboxConfirmation" />
          <p v-html="deviceSelectionPageMessages.checkboxDescription"></p>
        </div>
      </section>

      <div class="next_submit">
        <button
          class="btn_next"
          :class="{ btn_next_active: buttonActive }"
          @click="next"
        >
          {{ deviceSelectionPageMessages.buttonText }}
        </button>
      </div>
    </div>

    <alert-double-action
      v-if="warningModal.active"
      :warning="true"
      :description="warningModal.title"
      :message="warningModal.description"
      :action="warningModal.action"
      :secondaryAction="warningModal.secondaryAction"
      @mainButtonTrigger="mainTrigger"
      @secondButtonTrigger="secondTrigger"
      @close="closeModal"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "../components/HeaderComponent.vue";
import AlertDoubleAction from "../components/AlertDoubleAction.vue";
import trackEvent from "@/services/trackEvent";
export default {
  name: "DeviceSelection",
  components: { HeaderComponent, AlertDoubleAction },
  data() {
    return {
      brandSelected: "",
      modelSelected: "",
      brandsList: "",
      modelsByBrand: "",
      brandListSize: 1,
      modelListSize: 1,
      checkboxConfirmation: false,
      brandSelectionOpened: false,
      modelSelectionOpened: false,
      warningModal: {
        active: false,
      },
    };
  },
  computed: {
    buttonActive() {
      return (
        this.brandSelected && this.modelSelected && this.checkboxConfirmation
      );
    },
    ...mapState({
      config: (state) => state.config,
      devicesAcceptingESim: (state) => state.config.devicesAcceptingESim,
      anotherBrandModalMessage: (state) =>
        state.config.anotherBrandModalMessage,
      anotherModelModalMessage: (state) =>
        state.config.anotherModelModalMessage,
      deviceSelectionPageMessages: (state) =>
        state.config.deviceSelectionPageMessages,
      customer: (state) => state.customer,
      selectedBrand: (state) => state.selectedBrand,
    }),
  },
  created() {
    this.sendTracker("compatibilidade esim", 3);
    this.brandsList = this.devicesAcceptingESim.map((deviceElement) => {
      return deviceElement.brand;
    });

    this.getModelsByBrandSelected();
  },
  watch: {
    brandSelected() {
      this.getModelsByBrandSelected();
    },
  },
  methods: {
    closeModal() {
      this.warningModal.active = false;
    },
    mainTrigger() {
      this.sendTracker("incompativel continuar");
      if (this.warningModal.triggerAction.do == "proceed") {
        this.$router.push({ name: "documents" });
      } else if (this.warningModal.triggerAction.do == "redirect") {
        window.location.href = this.warningModal.triggerAction.to;
      }
    },
    secondTrigger() {
      this.sendTracker("incompativel procurar loja");
      if (this.warningModal.secondaryTriggerAction.do == "proceed") {
        this.$router.push({ name: "documents" });
      } else if (this.warningModal.secondaryTriggerAction.do == "redirect") {
        window.location.href = this.warningModal.secondaryTriggerAction.to;
      }
    },
    next() {
      this.sendTracker(
        `compatibilidade esim continuar_${this.brandSelected}_${this.modelSelected}`
      );

      if (this.buttonActive) {
        if (this.brandSelected == "Outras marcas") {
          this.sendTracker("modelo ou marca incompativel", 3);
          this.warningModal = {
            active: true,
            ...this.anotherBrandModalMessage,
          };
          return;
        }

        if (this.modelSelected == "Outros modelos") {
          this.warningModal = {
            active: true,
            ...this.anotherBrandModalMessage,
          };
          return;
        }

        this.$router.push({ name: "documents" });
      }
    },
    selectBrand(value) {
      this.brandSelected = value;
      this.modelSelected = "";
      this.brandSelectionOpened = false;
    },
    toggleBrandSelectionOpened() {
      this.brandSelectionOpened = !this.brandSelectionOpened;
      this.modelSelectionOpened = false;
    },
    toggleModelSelectionOpened() {
      this.modelSelectionOpened = !this.modelSelectionOpened;
      this.brandSelectionOpened = false;
    },
    selectModel(value) {
      this.modelSelected = value;
      this.modelSelectionOpened = false;
    },
    getModelsByBrandSelected() {
      const deviceListConfig = this.devicesAcceptingESim.find(
        (deviceElement) => {
          return deviceElement.brand == this.brandSelected;
        }
      );
        this.$store.dispatch("selectedBrand", this.brandSelected);
      if (deviceListConfig !== undefined) {
        this.modelsByBrand = deviceListConfig.models;
      }
    },
    sendTracker(eventLabel, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.isExOi() ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    isExOi() {
      if (this.config["init_flow"] === undefined) {
        this.alertError = true;
      }

      return JSON.parse(this.customer.isExOiCustomer);
    },
  },
};
</script>

<style lang="scss" scoped>
.device_selection {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 5%;
    > .page_title {
      font-family: "timsans_thin";
      font-size: 1.5rem;
      line-height: 1.875rem;
      text-align: center;
    }
    > .device_selection_container {
      margin-top: 2.125rem;
      display: flex;
      flex-direction: column;
      > .selection_container {
        position: relative;
        > .selection_input {
          width: 100%;
          height: 52px;
          padding: 0px 24px;
          border-radius: 26px;
          color: #b3b3b3;
          margin-bottom: 1.5rem;
          font-family: "timsans_regular";
          font-size: 1rem;
          -webkit-appearance: none;
          -moz-appearance: none;
          overflow: auto;
          border: 1px solid #b3b3b3;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        > .selection_options_container {
          display: none;
        }
        > .selection_options_container.opened_options {
          position: absolute;
          display: flex;
          width: 100%;
          max-height: 200px;
          overflow-y: scroll;
          overflow-x: hidden;
          flex-direction: column;
          background: #fff;
          border-radius: 16px;
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;
          > label {
            width: 100%;
            padding: 24px 0 0 24px;
            font-family: "timsans_regular";
            font-size: 0.875rem;
            color: #9c9c9c;
            line-height: 21px;
            cursor: pointer;
          }
          > label:last-child {
            padding-bottom: 24px;
          }
          > label:hover {
            background-color: #e7e7e7;
          }
        }
        > .selection_input::-ms-expand {
          display: none;
        }
        > .selection_input::after {
          content: "<";
          font: 20px "Consolas", monospace;
          color: #9c9c9c;
          -webkit-transform: rotate(180deg) scaleY(1.2);
          -moz-transform: rotate(270deg) scaleY(1.2);
          -ms-transform: rotate(270deg) scaleY(1.2);
          transform: rotate(270deg) scaleY(1.2);
          right: 40px;
          position: absolute;
          pointer-events: none;
        }
      }
      > .confirmation_container {
        display: flex;
        flex-direction: row;
        margin: 0px 8px;
        > input {
          width: 52px !important;
          height: 24px !important;
          -webkit-appearance: none;
          border: 1px solid #9c9c9c;
          background: #ffffff;
          color: #ffffff;
          text-align: center;
          border-radius: 8px;
          margin: 0 !important;
          background-position: center;
        }
        > input:checked {
          background-image: url("../assets/images/on-filled.svg");
          -webkit-appearance: none;
          border-color: transparent;
        }
        > p {
          margin-block: 0 !important;
          margin-left: 0.5rem;
          font-family: "timsans_regular";
          font-size: 0.875rem;
          color: #9c9c9c;
        }
      }
    }
    > .next_submit {
      position: absolute !important;
      bottom: 2.5rem;
      left: 0;
      margin: 0;
      > .btn_next {
        width: 80%;
      }
    }
  }
}
</style>